import React, { useEffect, useState } from "react";
import { Container, Row, Spinner, Alert } from "react-bootstrap";
import Right, { SocialPortfolioCard } from "./right";
import Personal from "./personal";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { jwtDecode } from "jwt-decode";
import {
  getProfileData,
  getUserData,
  updateCompany,
  getPaymentStatus,
  sendDocToS3,
  createUserProfile,
  updateUserProfile,
  createCompany,
  geCompanyData,
  updateUserImageProfile,
  updateUserSocialProfile,
} from "../../../slices/thunk";
import HomeOwnerPersonal from "./homeOwnerPersonal";
import withRouter from "Common/withRouter";
import { useTranslation, withTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { selectUserDetails } from "slices/userProfile/reducer";
import "./profile-settings-redesign.css";
import {
  getInitialProfileSettingSection,
  getLegacyTabFromSection,
  getSectionFromLegacyTab,
  isBusinessProfileUser,
  normalizeProfileSettingsSection,
  ProfileSettingsSectionId,
} from "./profileSettingsSections";
import api from "Common/api";

interface JwtPayload {
  userType: string;
}

const ProfileSetting = (props: any) => {
  const token = localStorage.getItem("authUser");
  let decoded: any = "";
  if (token !== null) {
    decoded = jwtDecode<JwtPayload>(token);
  } else {
    console.error("Token is null");
  }
  const { t } = useTranslation(); // ✅ React knows to update
  const [selectedInput,setSelectedInpt]= useState("")

  document.title = "Profile Settings";
  const location = useLocation();
  const userType = decoded?.userType || decoded?.user_type;
  const isContractorBillingUser = userType === "contractor" || userType === "testContractor";
  let user: any = [];
  const [loading, setLoading] = useState(false);
  const [notification, setNotification] = useState({
    show: false,
    variant: "",
    message: "",
  }); // Notification state

  const userData = useSelector((state: any) => state.UserProfile.userData);
  user = useSelector((state: any) => state.UserProfile.user);
  const company = useSelector((state: any) => state.ContractorCompany.company);
  const paymentverified = useSelector(
    (state: any) => state.Payment.paymentStatus
  );

  const [coverImagePath, setCoverImagePath] = useState<string>("");
  const [profileImagePath, setProfileImagePath] = useState<string>("");
  const [companyLicencePath, setCompanyLicencePath] = useState<string>("");
  const [contractorLicencePath, setContractorLicencePath] =
    useState<string>("");
  const [insurancePath, setInsurancePath] = useState<string>("");
  const [profileVideoPath, setProfileVideoPath] = useState<string>("");
  const [companyLogoPath, setCompanyLogoPath] = useState<string>("");
  const [companyLicenceLoading, setCompanyLicenceLoading] = useState(false);
  const [contInsuranceLoading, setContInsuranceLoading] = useState(false);
  const [contLicenceLoading, setContLicenceLoading] = useState(false);
  const [companyLogoLoading, setCompLogoLoading] = useState(false);
  const [profVideoLoading, setProfVideoLoading] = useState(false);
  const [identityLoading, setIdentityLoading] = useState(false);
  const [complianceUploadingType, setComplianceUploadingType] = useState<string | null>(null);
  const [socialSuccess, setSocialSuccess] = useState(false);
  const [activeSection, setActiveSection] =
    useState<ProfileSettingsSectionId>(() =>
      getInitialProfileSettingSection(location, userType)
    );
  const [socialItems, setSocialItems] = useState("");
   const [error,setError] = useState("")
  const dispatch: any = useDispatch();
const navigation = useNavigate()

  useEffect(() => {
    setActiveSection(getInitialProfileSettingSection(location, userType));
  }, [location.hash, location.search, userType]);

  //console.log(user, "useruseruser");
  useEffect(()=>{
    const path = localStorage.getItem("pending_path")
    if(path &&decoded?.user_type==="homeowner" ||path?.includes("Subcontractor") ){
    localStorage.removeItem("pending_path")
    navigation(path)
    
  
    

    }else{
      setLoading(true);
      dispatch(getProfileData())
    dispatch(getUserData())
      setLoading(false)
     
    if (isContractorBillingUser) {
      dispatch(getPaymentStatus())
    }
 
    
      dispatch(geCompanyData())
      
    }
  },[])


  const handleUser = (values: any,ignoreNextButton?:any,inputName?:any) => {
    let newCover = null;
    if (coverImagePath !== "") {
      newCover = coverImagePath;
    } else if (userData && userData.ua_cover_pic !== null) {
      newCover = userData.ua_cover_pic;
    }
    let newProfile = null;
    if (profileImagePath !== "") {
      newProfile = profileImagePath;
    } else if (userData && userData.ua_profile_pic !== null) {
      newProfile = userData.ua_profile_pic;
    }
    let newSocial = null;
    if (socialItems !== "") {
      newSocial = socialItems;
    } else if (userData && userData.ua_social_url !== null) {
      newSocial = userData.ua_social_url;
    }
    if (userData) {
      // setLoading(true);
      dispatch(updateUserProfile(values, newCover, newProfile, newSocial))
        .then(() => {
         

          dispatch(getProfileData());
          dispatch(getUserData());
          if(!ignoreNextButton){
            if (userType === "homeowner") {
              setActiveSection("profile");
            } else {
              setActiveSection("business");
            }
          }
          if(inputName){
            setSelectedInpt(inputName)
            setTimeout(() => {
            setSelectedInpt('')
              
            }, 5000);
          }else{
            toast.success("User profile updated successfully!");
          }
       

          // setLoading(false);
        
        })
        .catch(() => {
          setLoading(false);
          toast.warning("Failed to create user profile!");
        })
    } else {
      setLoading(true);
      dispatch(createUserProfile(values, newCover, newProfile, newSocial))
        .then(() => {
toast.success("User profile updated successfully!");

          dispatch(getProfileData());
          if(!ignoreNextButton){
            if (userType === "homeowner") {
              setActiveSection("profile");
            } else {
              setActiveSection("business");
            }
          }
       
          setLoading(false);

        })
        .catch(() => {
          setLoading(false);
          toast.warning("Failed to update user profile!");

        });
    }
  };

  const handleCompanyUpdateWithLogo = (type: any, newUrl: any) => {
    const companyD = company;
    const data = {
      companyName: (companyD && companyD.cc_company_name) || "",
      companyRegisterdNumber:
        (companyD && companyD.cc_company_registered_number) || "",
      companyPhoneNumber: (companyD && companyD.cc_phone_number) || "",
      companyEmail: (companyD && companyD.cc_company_email) || "",
      companyRegisterdDate: (companyD && companyD.cc_registration_date) || "",
      companyCity: (companyD && companyD.cc_city) || "",
      companyAddress: (companyD && companyD.cc_address) || "",
      companyState: (companyD && companyD.cc_state) || "",
      companyZip: (companyD && companyD.cc_zip_code) || "",
      companyCountry: (companyD && companyD.cc_country) || "",
      companyInsuranceDocument:
        (companyD && companyD.cc_insurance_documentation_url) || "",
      companyLicenceDocument:
        (companyD && companyD.cc_licence_documentation_url) || "",
      companyContractorDocument:
        (companyD && companyD.cc_contractor_documentation_url) || "",
      //companyLogo: (companyD && userD.user_last_name) || "",
    };
    handleCompany(data, type, newUrl);
  };

  const handleCompany = (values: any, type?: any, newUrl?: any,isIgnoreNextButton?:any,inputName?:any) => {

    let newCompanyLicence = null;
    if (companyLicencePath !== "") {
      newCompanyLicence = companyLicencePath;
    } else if (company && company.cc_licence_documentation_url !== null) {
      newCompanyLicence = company.cc_licence_documentation_url;
    }
    if (type === "companyLicence") {
      newCompanyLicence = newUrl;
    }

    let newContractorLicence = null;
    if (contractorLicencePath !== "") {
      newContractorLicence = contractorLicencePath;
    } else if (company && company.cc_contractor_documentation_url !== null) {
      newContractorLicence = company.cc_contractor_documentation_url;
    }
    if (type === "contractorLicence") {
      newContractorLicence = newUrl;
    }

    let newInsurance = null;
    if (insurancePath !== "") {
      newInsurance = insurancePath;
    } else if (company && company.cc_insurance_documentation_url !== null) {
      newInsurance = company.cc_insurance_documentation_url;
    }
    if (type === "insurance") {
      newInsurance = newUrl;
    }
    let newVideoUrl = null;
    if (profileVideoPath !== "") {
      newVideoUrl = profileVideoPath;
    } else if (company && company.cc_video_url !== null) {
      newVideoUrl = company.cc_video_url;
    }
    if (type === "profileVideo") {
      newVideoUrl = newUrl;
    }
    let newLogoUrl = null;
    if (companyLogoPath !== "") {
      newLogoUrl = companyLogoPath;
    } else if (company && company.cc_logo_url !== null) {
      newLogoUrl = company.cc_logo_url;
    }
    if (type === "newLogoUrl") {
      newLogoUrl = newUrl;
    }

    if (company != null) {
      dispatch(
        updateCompany(
          values,
          newCompanyLicence,
          newContractorLicence,
          newInsurance,
          newVideoUrl,
          newLogoUrl
        )
      )
        .then(() => {
          dispatch(geCompanyData());
          setLoading(false);
         if(inputName){
          setSelectedInpt(inputName)
          setTimeout(() => {
            setSelectedInpt("")
          }, 5000);
         }else{
          toast.success("Company profile updated successfully!");

         }
          if (
            userType === "real_estate_agent" ||
            userType === "broker"
          ) {
          toast.success("Broker profile created successfully!");



          } else {
            if(!isIgnoreNextButton){
            if (!type) {
              setActiveSection("payments");
            }}

         
          }
        })
        .catch(() => {
          setLoading(false);
          toast.warning("Failed to create company profile!");

        
        });
    } else {
      //console.log("In create");
      setLoading(true);
      dispatch(
        createCompany(
          values,
          newCompanyLicence,
          newContractorLicence,
          newInsurance,
          newVideoUrl,
          newLogoUrl
        )
      )
        .then(() => {
          dispatch(geCompanyData());
          setLoading(false);
          if(!isIgnoreNextButton){
            if (!type) {
              setActiveSection("payments");
            }
          }
          toast.success("Company profile updated successfully!");
         
      
        })
        .catch(() => {
          setLoading(false);
          toast.warning("Failed to update company profile!");

 
        });
    }
  };

  const handleSocialChange = (social: any) => {
    setSocialItems(social);
  };

  const handleCoverImageChange = (type: string, filePath: any) => {
    const usesSecureComplianceFlow =
      userType === "contractor" || userType === "subcontractor";

    if (
      usesSecureComplianceFlow &&
      ["identity", "insurance", "w9", "license"].includes(type)
    ) {
      setComplianceUploadingType(type);
      if (type === "identity") setIdentityLoading(true);
      if (type === "insurance") setContInsuranceLoading(true);
      if (type === "w9") setCompanyLicenceLoading(true);
      if (type === "license") setContLicenceLoading(true);

      const formData = new FormData();
      formData.append("file", filePath);

      return api
        .post(`/company/compliance/upload/${type}`, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then(() => {
          window.dispatchEvent(new CustomEvent("contractor-compliance-updated"));
          toast.success("Document uploaded securely. AI verification is running in the background.");
        })
        .catch((err: any) => {
          console.error("Compliance document upload failed:", err);
          toast.error(err?.response?.data?.message || "Document upload failed.");
          throw err;
        })
        .finally(() => {
          setComplianceUploadingType(null);
          if (type === "identity") setIdentityLoading(false);
          if (type === "insurance") setContInsuranceLoading(false);
          if (type === "w9") setCompanyLicenceLoading(false);
          if (type === "license") setContLicenceLoading(false);
        });
    }

    const analyzeComplianceDocument = async (documentType: string, documentUrl: string) => {
      try {
        await api.post("/company/compliance/analyze", { documentType, documentUrl });
        window.dispatchEvent(new CustomEvent("contractor-compliance-updated"));
        toast.success("Document uploaded and checked.");
      } catch (error) {
        window.dispatchEvent(new CustomEvent("contractor-compliance-updated"));
        toast.info("Document uploaded and queued for manual review.");
      }
    };

    //console.log(filePath, type, "ddddssss");
    if (type === "profile") {
      setLoading(true);
      dispatch(sendDocToS3(type, filePath))
        .then((resp: any) => {
          let userImg = {
            img: resp,
            imgType: "profilePic",
          };
          dispatch(updateUserImageProfile(userImg)).then(() => {
            dispatch(getProfileData());
          });
          setProfileImagePath(resp);
          setLoading(false);
        })
        .catch((err: any) => {
          // Handle error if needed
          console.error("Error:", err);
          setLoading(false);
        });
    }

    if (type === "cover") {
      setLoading(true);
      dispatch(sendDocToS3(type, filePath))
        .then((resp: any) => {
          let userImg = {
            img: resp,
            imgType: "coverPic",
          };
          dispatch(updateUserImageProfile(userImg)).then(() => {
            dispatch(getProfileData());
          });
          setCoverImagePath(resp);
          setLoading(false);
        })
        .catch((err: any) => {
          // Handle error if needed
          console.error("Error:", err);
          setLoading(false);
        });
    }

    if (type === "companyLicence") {
      setCompanyLicenceLoading(true);
      dispatch(sendDocToS3(type, filePath))
        .then(async (resp: any) => {
          setCompanyLicencePath(resp);
          setCompanyLicenceLoading(false);
          handleCompanyUpdateWithLogo(type, resp);
          if (resp) await analyzeComplianceDocument("w9", resp);
        })
        .catch((err: any) => {
          // Handle error if needed
          console.error("Error:", err);
        });
    }

    if (type === "insurance") {
      setContInsuranceLoading(true);
      dispatch(sendDocToS3(type, filePath))
        .then(async (resp: any) => {
          setInsurancePath(resp);
          handleCompanyUpdateWithLogo(type, resp);
          if (resp) await analyzeComplianceDocument("insurance", resp);
          setContInsuranceLoading(false);
        })
        .catch((err: any) => {
          // Handle error if needed
          setContInsuranceLoading(false);
          console.error("Error:", err);
        });
    }

    if (type === "contractorLicence") {
      setContLicenceLoading(true);
      dispatch(sendDocToS3(type, filePath))
        .then(async (resp: any) => {
          setContractorLicencePath(resp);
          setContLicenceLoading(false);
          handleCompanyUpdateWithLogo(type, resp);
          if (resp) await analyzeComplianceDocument("license", resp);
        })
        .catch((err: any) => {
          // Handle error if needed
          setContLicenceLoading(false);
          console.error("Error:", err);
        });
    }

    if (type === "companyLogo") {
      setCompLogoLoading(true);
      dispatch(sendDocToS3(type, filePath))
        .then((resp: any) => {
          setCompanyLogoPath(resp);
          setCompLogoLoading(false);
          handleCompanyUpdateWithLogo("newLogoUrl", resp);
        })
        .catch((err: any) => {
          // Handle error if needed
          setCompLogoLoading(false);
          console.error("Error:", err);
        });
    }

    if (type === "profileVideo") {
      setProfVideoLoading(true);
      dispatch(sendDocToS3(type, filePath))
        .then((resp: any) => {
          setProfileVideoPath(resp);
          handleCompanyUpdateWithLogo(type, resp);
          setProfVideoLoading(false);
        })
        .catch((err: any) => {
          // Handle error if needed
          setProfVideoLoading(false);
          console.error("Error:", err);
        });
    }

    if (type === "profile") {
      dispatch(sendDocToS3(type, filePath))
        .then((resp: any) => {
          setProfileImagePath(resp);
        })
        .catch((err: any) => {
          // Handle error if needed
          console.error("Error:", err);
        });
    }
  };

  function handleRemoveImage(type: any) {
    if (type === "insuranceDocumentation") {
      setInsurancePath("");
    }
    if (type === "licenceDocumentation") {
      setCompanyLicencePath("");
    }
    if (type === "contractorLicence") {
      setContractorLicencePath("");
    }
    if (type === "profileVideo") {
      setProfileVideoPath("");
    }
    if (type === "companyLogo") {
      setCompanyLogoPath("");
    }
    //console.log(type, "Tett Remove");
  }
  const handleTab = (type: any) => {
    const nextSection = getSectionFromLegacyTab(type);
    setActiveSection(normalizeProfileSettingsSection(nextSection, userType));
  };

  useEffect(()=>{
if(notification?.show){
 setTimeout(() => {
   setNotification(p=>{
     return{
       ...p,
       show:false
     }
   })
 }, 5000);
}
  },[notification])

  //handle social submit
  const handleSocialSubmit = (values?:any) => {
    dispatch(updateUserSocialProfile( values?values:socialItems));
    toast.success("User Social Media url's added successfully!");

  
 
    setLoading(false);
  };

  let paymentCount = paymentverified === 1 ? 40 : 0;
  let userProfileCount =
    userData && userData.ua_completed != null
      ? Number(userData.ua_completed)
      : 0;
  let userCompanyCount =
    company && company.cc_completed != null ? Number(company.cc_completed) : 0;

  const profileCompleted = userProfileCount + userCompanyCount + paymentCount;
  //console.log(company, "1234")
  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const payment = urlParams.get("payment");
    if (payment === "success") {
    toast.success("Payment was successful! Your video payment status has been updated.");

   
    }
    if (payment === "failure") {
    toast.warning("Payment was failed! Your video payment status has been updated.");

    
    }
  }, [location]);
  const userd:any = useSelector(selectUserDetails)
  if(!userd){
    return <div></div>
  }
  const activeLegacyTab = getLegacyTabFromSection(activeSection);
  const mobilePortfolio = (
    <SocialPortfolioCard
      data={userData}
      onSocialChange={(e) => {
        handleSocialChange(e);
      }}
      createUserData={handleSocialSubmit}
      className="profile-settings-mobile-social-card"
    />
  );
  return (
    <React.Fragment>
      <div className="page-content profile-settings-page">
        {loading && (
          <div
            className="profile-settings-loading-indicator"
            role="status"
            aria-live="polite"
          >
            <span className="profile-settings-loading-bar" aria-hidden="true" />
            <span className="profile-settings-loading-pill">
              <Spinner animation="border" size="sm" aria-hidden="true" />
              <span>{t("Saving changes...")}</span>
            </span>
          </div>
        )}
        {notification.show && (
          <Alert
            variant={notification.variant}
            onClose={() =>
              setNotification({ show: false, variant: "", message: "" })
            }
            dismissible
          >
            {notification.message}
          </Alert>
        )}
        <Container fluid className="profile-settings-container">
          <Row className="profile-settings-layout g-4">
            <Right
              userData={user[0]}
              data={userData}
              profileCompleted={profileCompleted}
              onFileChange={handleCoverImageChange}
              onSocialChange={(e)=>{
                handleSocialChange(e)
              }}
              createUserData={handleSocialSubmit}
              successSoc={socialSuccess}
              isLoading={loading}
            />
           
            {isBusinessProfileUser(userType) ? (
              <Personal
                data={userData}
                error={error}
                props={props}
                userType={userType}
                userD={user[0]}
                selectedInput={selectedInput}
                companyD={company}
                isLoading={loading}
                licenceImage={
                  company && company.cc_licence_documentation_url != null
                    ? company.cc_licence_documentation_url
                    : companyLicencePath
                }
                contractorLicenceImage={
                  company && company.cc_contractor_documentation_url != null
                    ? company.cc_contractor_documentation_url
                    : contractorLicencePath
                }
                insuranceImage={
                  company && company.cc_insurance_documentation_url != null
                    ? company.cc_insurance_documentation_url
                    : insurancePath
                }
                createUserData={handleUser}
                createCompanyData={handleCompany}
                onFileChange={handleCoverImageChange}
                onRemoveImage={handleRemoveImage}
                isPaymentVerified={true} //paymentverified}
                companyLicLoading={companyLicenceLoading}
                insuranceLoading={contInsuranceLoading}
                contLicLoading={contLicenceLoading}
                compLogo={
                  company && company.cc_logo_url != null
                    ? company.cc_logo_url
                    : companyLogoPath
                }
                compLogoLoading={companyLogoLoading}
                profileVideo={
                  company && company.cc_video_url != null
                    ? company.cc_video_url
                    : profileVideoPath
                }
                profileVidLoading={profVideoLoading}
                identityLoading={identityLoading}
                complianceUploadingType={complianceUploadingType}
                activeT={activeLegacyTab}
                handleActivetab={handleTab}
                mobilePortfolio={mobilePortfolio}
              />
            ) : (
              <HomeOwnerPersonal
                data={userData}
                userD={user[0]}
                companyD={company}
                isLoading={loading}
                licenceImage={
                  company && company.cc_licence_documentation_url != null
                    ? company.cc_licence_documentation_url
                    : companyLicencePath
                }
                contractorLicenceImage={
                  company && company.cc_contractor_documentation_url != null
                    ? company.cc_contractor_documentation_url
                    : contractorLicencePath
                }
                insuranceImage={
                  company && company.cc_insurance_documentation_url != null
                    ? company.cc_insurance_documentation_url
                    : insurancePath
                }
                createUserData={handleUser}
                createCompanyData={handleCompany}
                onFileChange={handleCoverImageChange}
                onRemoveImage={handleRemoveImage}
                isPaymentVerified={paymentverified}
                companyLicLoading={companyLicenceLoading}
                insuranceLoading={contInsuranceLoading}
                contLicLoading={contLicenceLoading}
                selectedInput={selectedInput}
                compLogo={
                  company && company.cc_logo_url != null
                    ? company.cc_logo_url
                    : companyLogoPath
                }
                compLogoLoading={companyLogoLoading}
                profileVideo={
                  company && company.cc_video_url != null
                    ? company.cc_video_url
                    : profileVideoPath
                }
                profileVidLoading={profVideoLoading}
                activeT={activeLegacyTab}
                handleActivetab={handleTab}
                mobilePortfolio={mobilePortfolio}
              />
            )}
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(withTranslation()(ProfileSetting));
